// Module
var code = "<div class=\"tbx-modal\" ng-click=\"$dismiss()\"> <div class=\"modal-body\" id=\"modal-body\"> <img class=\"tbx-bd-img-lg img-responsive img-rotated\" ng-show=\"photo.image\" ng-src=\"{{photo.image}}\" id=\"modal-{{photo.id}}\">  </div> </div> ";
// Exports
module.exports = code;